import { render, staticRenderFns } from "./MegaMenuLevelOneMobile.vue?vue&type=template&id=6dd18644&scoped=true&"
import script from "./MegaMenuLevelOneMobile.vue?vue&type=script&lang=js&"
export * from "./MegaMenuLevelOneMobile.vue?vue&type=script&lang=js&"
import style0 from "./MegaMenuLevelOneMobile.vue?vue&type=style&index=0&id=6dd18644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd18644",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsChevronLeft16px: require('/var/www/packages/theme/components/icons/chevron-left/ChevronLeft16px.vue').default,IconsChevronRight16px: require('/var/www/packages/theme/components/icons/chevron-right/ChevronRight16px.vue').default})
